var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00667 7.47998V10.4733C2.00667 13.4666 3.20667 14.6666 6.2 14.6666H9.79333C12.7867 14.6666 13.9867 13.4666 13.9867 10.4733V7.47998",
    stroke: "#7D7E7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99999 8.00004C9.21999 8.00004 10.12 7.00671 9.99999 5.78671L9.55999 1.33337H6.44666L5.99999 5.78671C5.87999 7.00671 6.77999 8.00004 7.99999 8.00004Z",
    stroke: "#7D7E7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2067 8.00004C13.5533 8.00004 14.54 6.90671 14.4067 5.56671L14.22 3.73337C13.98 2.00004 13.3133 1.33337 11.5667 1.33337H9.53334L10 6.00671C10.1133 7.10671 11.1067 8.00004 12.2067 8.00004Z",
    stroke: "#7D7E7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.76 8.00004C4.86 8.00004 5.85333 7.10671 5.96 6.00671L6.10666 4.53337L6.42666 1.33337H4.39333C2.64666 1.33337 1.98 2.00004 1.74 3.73337L1.56 5.56671C1.42666 6.90671 2.41333 8.00004 3.76 8.00004Z",
    stroke: "#7D7E7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99999 11.3334C6.88666 11.3334 6.33333 11.8867 6.33333 13V14.6667H9.66666V13C9.66666 11.8867 9.11333 11.3334 7.99999 11.3334Z",
    stroke: "#7D7E7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/shop.3f51e07ae00a9481f8ac8ba507a4813a.svg";
export { ForwardRef as ReactComponent };